<template>
    <ShowUserProfile @edit="editProfile" />

    <SectionWrapper borderPosition="bottom" id="account">
        <template #title>
            {{ $t('payment_methods') }}
        </template>
        <template #content>
            <SinglePaymentMethod v-if="selectedExistingPaymentMethod" :paymentMethod="getPaymentMethods.data.find((method) => method.id === selectedExistingPaymentMethod)" />
            <NewPaymentMethod :isOverview="true" v-else-if="selectedNewPaymentMethod" :paymentMethod="newPaymentMethods.find((method) => method.id === selectedNewPaymentMethod)" />
        </template>
    </SectionWrapper>

    <FormButton @click="editPaymentmethod" class="text-blue" :value="$t('edit_payment_method')" />
</template>

<script>
import { mapGetters } from 'vuex';
import { wTrans } from 'laravel-vue-i18n';
import i18next from 'i18next';

export default {
    data: () => ({
        messages: null,
        newPaymentMethods: [
            {
                name: 'payment_creditcard',
                id: 'CREDITCARD'
            },
            {
                name: wTrans('PayPal'),
                id: 'PAYPAL'
            },
            {
                name: wTrans('Google Pay'),
                id: 'GOOGLEPAY'
            },
            {
                name: wTrans('Apple Pay'),
                id: 'APPLEPAY'
            }
        ]
    }),
    methods: {
        editProfile() {
            this.$emit('editProfile');
        },
        editPaymentmethod() {
            this.$emit('editPaymentmethod');
        }
    },
    props: {
        selectedExistingPaymentMethod: String,
        selectedNewPaymentMethod: String
    },
    emits: ['editProfile', 'editPayment'],
    computed: {
        ...mapGetters('payment_methods', {
            getPaymentMethods: 'get'
        })
    }
};
</script>
